<template>
  <div class="wx">
    <el-dialog title="微信开户信息"
               :visible.sync="dialogVisible"
               width="768px"
               :before-close="handleClose">
      <div class="main scroll-auto">
        <div class="step">
          <el-steps :space="200"
                    :active="step"
                    align-center
                    finish-status="success">
            <el-step title="确认信息"></el-step>
            <el-step title="填写结算账户"></el-step>
            <el-step title="填写超级管理员"></el-step>
          </el-steps>
        </div>
        <div class="form-list">
          <div class="step-0"
               v-show="step == 0">
            <el-form :model="ruleFormStep1"
                     :rules="rulesStep1"
                     ref="ruleFormStep1"
                     label-width="160px"
                     class="demo-ruleFormStep1"
                     label-position="right">
              <el-form-item label="营业执照："
                            prop="business_file">
                <el-upload action="#"
                           list-type="picture-card"
                           :auto-upload="false"
                           :file-list="ruleFormStep1.business_file"
                           :class="ruleFormStep1.business_file.length == 1 ? 'mf' : ''"
                           :on-change="(file, fileList) => handleChange(file, fileList, 0)"
                           :on-remove="(file, fileList) => handleRemove(file, fileList, 0)">
                  <i slot="default"
                     class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="主体类型："
                            prop="body_type">
                <el-select v-model="ruleFormStep1.body_type">
                  <el-option value="1"
                             label="个人"></el-option>
                  <el-option value="1"
                             label="企业"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件注册号："
                            prop="business_license_number">
                <el-input v-model="ruleFormStep1.business_license_number"
                          clearable></el-input>
              </el-form-item>
              <el-form-item label="商户名称："
                            prop="merchant_name">
                <el-input v-model="ruleFormStep1.merchant_name"
                          clearable></el-input>
              </el-form-item>
              <el-form-item label="法定人身份证正面："
                            prop="legal_cert_front_file">
                <el-upload action="#"
                           list-type="picture-card"
                           :auto-upload="false"
                           :file-list="ruleFormStep1.legal_cert_front_file"
                           :class="ruleFormStep1.legal_cert_front_file.length == 1 ? 'mf' : ''"
                           :on-change="(file, fileList) => handleChange(file, fileList, 1)"
                           :on-remove="(file, fileList) => handleRemove(file, fileList, 1)">
                  <i slot="default"
                     class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="法定人身份证反面："
                            prop="legal_cert_back_file">
                <el-upload action="#"
                           list-type="picture-card"
                           :auto-upload="false"
                           :file-list="ruleFormStep1.legal_cert_back_file"
                           :class="ruleFormStep1.legal_cert_back_file.length == 1 ? 'mf' : ''"
                           :on-change="(file, fileList) => handleChange(file, fileList, 2)"
                           :on-remove="(file, fileList) => handleRemove(file, fileList, 2)">
                  <i slot="default"
                     class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="法人证件类型："
                            prop="id_type"
                            required>
                <el-select v-model="ruleFormStep1.id_type">
                  <el-option value="IDENTIFICATION_TYPE_MAINLAND_IDCARD"
                             label="中国大陆居民-身份证"></el-option>
                  <el-option value="IDENTIFICATION_TYPE_OVERSEA_PASSPORT"
                             label="其他国家或地区居民-护照"></el-option>
                  <el-option value="IDENTIFICATION_TYPE_HONGKONG"
                             label="中国香港居民–来往内地通行证"></el-option>
                  <el-option value="IDENTIFICATION_TYPE_MACAO"
                             label="中国澳门居民–来往内地通行证"></el-option>
                  <el-option value="IDENTIFICATION_TYPE_TAIWAN"
                             label="中国台湾居民–来往大陆通行证"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="法人身份证姓名："
                            prop="real_name">
                <el-input v-model="ruleFormStep1.real_name"
                          clearable></el-input>
              </el-form-item>
              <el-form-item label="法人身份证号码："
                            prop="id_number">
                <el-input v-model="ruleFormStep1.id_number"
                          clearable></el-input>
              </el-form-item>
              <el-form-item label="法人身份证有效期："
                            prop="validity_type">
                <el-radio-group v-model="ruleFormStep1.validity_type">
                  <el-radio label="1">长期</el-radio>
                  <el-radio label="2">选择日期</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label=""
                            v-if="ruleFormStep1.validity_type == 2">
                <!--    <el-date-picker v-model="ruleFormStep1.id_validity" type="date" placeholder="选择日期"> </el-date-picker> -->
                <el-date-picker v-model="ruleFormStep1.id_validity"
                                type="daterange"
                                clearable
                                value-format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" />
              </el-form-item>
            </el-form>
          </div>
          <div class="step-1"
               v-show="step == 1">
            <el-form :model="ruleFormStep2"
                     :rules="rulesStep2"
                     ref="ruleFormStep2"
                     label-width="180px"
                     class="demo-ruleFormStep1"
                     label-position="right">
              <el-form-item label="商户简称："
                            prop="merchant_store_name">
                <el-input v-model="ruleFormStep2.merchant_store_name"
                          clearable></el-input>
                <p class="tip">将在支付完成页向买家展示</p>
              </el-form-item>
              <el-form-item label="账户类型："
                            prop="open_account_type">
                <el-select v-model="ruleFormStep2.open_account_type">
                  <el-option value="75"
                             label="个人"></el-option>
                  <el-option value="74"
                             label="企业"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开户银行："
                            prop="open_bank">
                <el-input v-model="ruleFormStep2.open_bank"
                          clearable></el-input>
              </el-form-item>
              <el-form-item label="开户名称："
                            prop="open_merchant_name">
                <el-input v-model="ruleFormStep2.open_merchant_name"
                          clearable></el-input>
                <p class="tip">开户名称必须与营业执照上的“商户名称”一致</p>
              </el-form-item>
              <el-form-item label="开户银行联行号："
                            prop="open_bank_no">
                <el-input v-model="ruleFormStep2.open_bank_no"
                          clearable></el-input>
              </el-form-item>
              <el-form-item label="开户银行全称 (含支行)："
                            prop="open_bank_name">
                <el-input v-model="ruleFormStep2.open_bank_name"
                          clearable></el-input>
                <p class="tip">如“深圳农村商业银行****支行”</p>
              </el-form-item>
              <el-form-item label="开户银行省市编码："
                            prop="open_province_city">
                <el-input v-model="ruleFormStep2.open_province_city"
                          clearable></el-input>
                <p class="tip">省市区编号对照表，<a href="http://114.113.144.175:8907/%E7%9C%81%E5%B8%82%E5%8C%BA%E7%BC%96%E5%8F%B7%E5%AF%B9%E7%85%A7%E8%A1%A8.xlsx">点击下载</a></p>
              </el-form-item>
              <el-form-item label="银行账号："
                            prop="open_bank_account">
                <el-input v-model="ruleFormStep2.open_bank_account"
                          clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="step-2"
               v-show="step == 2">
            <el-form :model="ruleFormStep3"
                     :rules="rulesStep3"
                     ref="ruleFormStep3"
                     label-width="220px"
                     class="demo-ruleFormStep1"
                     label-position="right">
              <el-form-item label="超级管理员类型："
                            prop="admin_type">
                <el-select v-model="ruleFormStep3.admin_type">
                  <el-option value="65"
                             label="个人"></el-option>
                  <el-option value="66"
                             label="企业"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="超级管理员姓名："
                            prop="admin_name">
                <el-input v-model="ruleFormStep3.admin_name"
                          clearable></el-input>
                <p class="tip">后续该管理员使用实名微信号完成签约</p>
              </el-form-item>
              <el-form-item label="超级管理员身份证证件号码："
                            prop="admin_id_card">
                <el-input v-model="ruleFormStep3.admin_id_card"
                          clearable></el-input>
                <p class="tip">超级管理员签约时，校验微信号绑定的银行卡实名信息， 是否与该证件号码一致</p>
              </el-form-item>
              <el-form-item label="超级管理员手机："
                            prop="admin_mobile">
                <el-input v-model="ruleFormStep3.admin_mobile"
                          clearable></el-input>
                <p class="tip">用于接受微信支付的重要管理信息及日常操作验证码</p>
              </el-form-item>
              <el-form-item label="超级管理员邮箱："
                            prop="admin_email">
                <el-input v-model="ruleFormStep3.admin_email"
                          clearable></el-input>
                <p class="tip">用于接收微信支付的开户邮件及日常业务通知</p>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <div v-show="step == 0">
          <el-button type="primary"
                     @click="Next('ruleFormStep1')">下一步</el-button>
        </div>
        <div v-show="step == 1">
          <el-button type="primary"
                     @click="step -= 1">上一步</el-button>
          <el-button type="primary"
                     @click="Next('ruleFormStep2')">下一步</el-button>
        </div>
        <div v-show="step == 2">
          <el-button type="primary"
                     @click="step -= 1">上一步</el-button>
          <el-button type="primary"
                     @click="submit('ruleFormStep3')">提 交</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data () {
    var checkIdCard = (rule, value, cb) => {
      const regIdCard = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (regIdCard.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的身份证号"));
    };
    var checkMobile = (rule, value, cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
      if (regMobile.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的手机号"));
    };
    return {
      dialogVisible: false,
      step: 0,
      ruleFormStep1: {
        body_type: "",
        merchant_name: "",
        business_license_number: "",
        id_type: "",
        real_name: "",
        id_number: "",
        validity_type: "1",
        id_validity: [],
        id_front: "",
        id_back: "",
        business_license_copy: "",
        business_license_copy_url: "",
        id_front_url: "",
        id_back_url: "",
        business_file: [],
        legal_cert_front_file: [],
        legal_cert_back_file: [],
      },
      rulesStep1: {
        business_file: [{ required: true, message: "请上传营业执照", trigger: "change" }],
        body_type: [{ required: true, message: "请选择主体类型", trigger: "change" }],
        merchant_name: [{ required: true, message: "请输入商户名称", trigger: "blur" }],
        business_license_number: [{ required: true, message: "请输入证件注册号", trigger: "blur" }],
        legal_cert_front_file: [{ required: true, message: "法定人身份证正面", trigger: "change" }],
        legal_cert_back_file: [{ required: true, message: "法定人身份证反面", trigger: "change" }],
        id_type: [{ required: true, message: "请选择法人证件类型", trigger: "change" }],
        real_name: [{ required: true, message: "请输入法人身份证姓名", trigger: "blur" }],
        id_number: [{ required: true, message: "输入法人身份证号码", trigger: "blur" }],
        validity_type: [{ required: true, message: "请选择法人身份证有效期", trigger: "change" }],
      },
      ruleFormStep2: {
        merchant_store_name: "",
        open_account_type: "",
        open_bank: "",
        open_merchant_name: "",
        open_bank_no: "",
        open_bank_name: "",
        open_province_city: "",
        open_bank_account: "",
      },
      rulesStep2: {
        merchant_store_name: [{ required: true, message: "请输入商户简称", trigger: "blur" }],
        open_account_type: [{ required: true, message: "请选择账户类型", trigger: "change" }],
        open_bank: [{ required: true, message: "请输入开户银行", trigger: "blur" }],
        open_merchant_name: [{ required: true, message: "请输入开户名称", trigger: "blur" }],
        open_bank_no: [{ required: true, message: "请输入开户银行联行号", trigger: "blur" }],
        open_bank_name: [{ required: true, message: "请输入开户银行全称 (含支行)", trigger: "blur" }],
        open_province_city: [{ required: true, message: "请输入开户银行省市编码", trigger: "blur" }],
        open_bank_account: [{ required: true, message: "请输入银行账号", trigger: "blur" }],
      },
      ruleFormStep3: {
        admin_type: "",
        admin_name: "",
        admin_id_card: "",
        admin_mobile: "",
        admin_email: "",
      },
      rulesStep3: {
        admin_type: [{ required: true, message: "请选择管理员类型", trigger: "change" }],
        admin_name: [{ required: true, message: "请输入管理员名称", trigger: "blur" }],
        admin_id_card: [{ required: true, message: "请输入管理员身份证", trigger: "blur" }],
        admin_mobile: [
          {
            required: true,
            message: "请输入超级管理员电话",
            trigger: "blur",
          },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号" },
        ],
        admin_email: [
          {
            required: true,
            message: "请输入超级管理员邮箱",
            trigger: "blur",
          },
          {
            pattern: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
            message: "请输入正确的邮箱地址",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getToken", "getUserInfo"]),
  },
  mounted() {
    console.log(5)
  },
  methods: {
    ...mapActions({
      wxUpload: "detect/wxUpload",
      openAccountWx: "detect/openAccountWx",
      uploadFile: "commodity/uploadFile",
    }),
    Next (formName) {
      // this.step += 1;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.step += 1;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let {
            id_front_url,
            id_back_url,
            business_license_copy_url,
            business_license_copy,
            body_type,
            merchant_name,
            business_license_number,
            id_front,
            id_back,
            id_type,
            real_name,
            id_number,
            validity_type,
            id_validity,
          } = this.ruleFormStep1;
          let { merchant_store_name, open_account_type, open_bank, open_merchant_name, open_bank_no, open_bank_name, open_province_city, open_bank_account } = this.ruleFormStep2;
          let { admin_type, admin_name, admin_id_card, admin_mobile, admin_email } = this.ruleFormStep3;
          let params = {
            token: this.getToken,
            organization_type: "2",
            user_id: this.$getSessionStorage("userid"),
            business_license_copy_url,
            business_license_copy,
            body_type,
            merchant_name,
            business_license_number,
            id_front_url,
            id_back_url,
            id_front,
            id_back,
            id_type,
            real_name,
            id_number,
            id_validity: validity_type == 1 ? "长期" : id_validity,
            merchant_store_name,
            open_account_type,
            open_bank,
            open_merchant_name,
            open_bank_no,
            open_bank_name,
            open_province_city,
            open_bank_account,
            admin_type,
            admin_name,
            admin_id_card,
            admin_mobile,
            admin_email,
          };
          this.openAccountWx(params).then(({ data }) => {
            console.log(data);
            if (data.code == 1) {
              this.$message.success("提交成功！");
              this.handleClose();
            } else {
              this.$message.error(data.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose () {
      this.dialogVisible = false;
      this.step = 0;
      this.$refs.ruleFormStep1.resetFields();
      this.$refs.ruleFormStep2.resetFields();
      this.$refs.ruleFormStep3.resetFields();
      this.ruleFormStep1 = {
        body_type: "",
        merchant_name: "",
        business_license_number: "",
        id_type: "",
        real_name: "",
        id_number: "",
        validity_type: "1",
        id_validity: "",
        id_front: "",
        id_back: "",
        business_license_copy: "",
        business_license_copy_url: "",
        id_front_url: "",
        id_back_url: "",
        business_file: [],
        legal_cert_front_file: [],
        legal_cert_back_file: [],
      };
      this.ruleFormStep2 = {
        merchant_store_name: "",
        open_account_type: "",
        open_bank: "",
        open_merchant_name: "",
        open_bank_no: "",
        open_bank_name: "",
        open_province_city: "",
        open_bank_account: "",
      };
      this.ruleFormStep3 = {
        admin_type: "",
        admin_name: "",
        admin_id_card: "",
        admin_mobile: "",
        admin_email: "",
      };
    },
    handleChange (file, fileList, index) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      var formdata1 = new FormData();
      formdata1.append("file", file.raw);
      formdata1.append("token", this.getToken);
      switch (index) {
        case 0:
          this.ruleFormStep1.business_file = fileList;
          if (this.ruleFormStep1.business_file.length > 0) {
            this.$refs.ruleFormStep1.clearValidate("business_file");
          }
          break;
        case 1:
          this.ruleFormStep1.legal_cert_front_file = fileList;
          if (this.ruleFormStep1.legal_cert_front_file.length > 0) {
            this.$refs.ruleFormStep1.clearValidate("legal_cert_front_file");
          }
          break;
        case 2:
          this.ruleFormStep1.legal_cert_back_file = fileList;
          if (this.ruleFormStep1.legal_cert_back_file.length > 0) {
            this.$refs.ruleFormStep1.clearValidate("legal_cert_back_file");
          }
          break;
        default:
          break;
      }
      this.wxUpload(formdata1).then((res) => {
        if (res.status == 200) {
          this.$message.success("上传成功！");
          switch (index) {
            case 0:
              this.ruleFormStep1.business_license_copy = res.data.media_id;
              break;
            case 1:
              this.ruleFormStep1.id_front = res.data.media_id;
              break;
            case 2:
              this.ruleFormStep1.id_back = res.data.media_id;
              break;
            default:
              break;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          // console.log(res);
          // this.$message.success("上传成功！");
          switch (index) {
            case 0:
              this.ruleFormStep1.business_license_copy_url = res.data.formdata_details[0].urls;
              break;
            case 1:
              this.ruleFormStep1.id_front_url = res.data.formdata_details[0].urls;
              break;
            case 2:
              this.ruleFormStep1.id_back_url = res.data.formdata_details[0].urls;
              break;
            default:
              break;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    handleRemove (file, fileList, index) {
      switch (index) {
        case 0:
          this.ruleFormStep1.business_file.map((item, index) => {
            if (item.name == file.name) {
              this.ruleFormStep1.business_file.splice(index, 1);
              this.rulesStep1.business_file = [{ required: true, message: "请上传营业执照", trigger: "change" }];
            }
          });
          break;
        case 1:
          this.ruleFormStep1.legal_cert_front_file.map((item, index) => {
            if (item.name == file.name) {
              this.ruleFormStep1.legal_cert_front_file.splice(index, 1);
              if (item.name == file.name) {
                this.ruleFormStep1.business_file.splice(index, 1);
                this.rulesStep1.legal_cert_front_file = [{ required: true, message: "请上传法定人身份证", trigger: "change" }];
              }
            }
          });
          break;
        case 2:
          this.ruleFormStep1.legal_cert_back_file.map((item, index) => {
            if (item.name == file.name) {
              this.ruleFormStep1.legal_cert_back_file.splice(index, 1);
              if (item.name == file.name) {
                this.ruleFormStep1.business_file.splice(index, 1);
                this.rulesStep1.business_file = [{ required: true, message: "请上传法定人身份证", trigger: "change" }];
              }
            }
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wx {
  .main {
    max-height: 500px;
    padding-bottom: 30px;
    .step {
      text-align: center;
      margin-bottom: 40px;
      .el-steps {
        justify-content: center;
      }
    }
    .form-list {
      ::v-deep .el-input--medium .el-input__inner,
      .el-input {
        width: 400px !important;
      }
    }
  }
  .tip {
    font-size: 12px;
    color: #999;
  }
}
.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
</style>